import Swal from 'sweetalert2';

export const SweetAlertBasic = (icon, title, text) => {
  return Swal.fire({
    icon,
    title,
    text,
  });
};

export const SweetAlertConfirm = (name, title, textTitle, confirm) => {
  return Swal.fire({
    title: textTitle,
    text: title + name,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si',
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire('¡Exitoso!', `El archivo: ${name} fue ${confirm} exitosamente`, 'success');
    }
  });
};
